<ndt-user-password-reset-view
   (passwordReset)="onSubmit($event)"
   [loading]="loading$ | async"
></ndt-user-password-reset-view>
